import {
  selectCoordinates,
  dragDropPieces,
  highlightCoordinates
} from './assignments'
import { createChessboard } from '../../utils'

let lessonConfig = [
  {
    id: 0,
    previous: null,
    next: 3,
    video: {
      src: 'img/videos/lesson_1/1.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 1
    }
  },
  {
    id: 1,
    previous: 0,
    next: 3,
    directions: {
      data: `<b>DIRECTIONS:</b> <br/>Click on the 10 <br/>squares that should <br/>be dark.`,
      timeout: 5000
    },
    audio: { src: 'img/audio/lesson_1/1.mp3', start: true, controls: false },
    chessboard: {
      board: selectCoordinates({
        squares: ['.square-b6', '.square-d6', '.square-f6', '.square-b4', '.square-c3', '.square-c5', '.square-f2', '.square-h8', '.square-e3', '.square-f4'],
        indicators: false,
        assignmentClass: 'assignment-1-1',
        coordinateClass: 'white-coordinate',
        next: 2
      })
    }
  },
  {
    id: 2,
    previous: 0,
    next: 5,
    video: {
      src: 'img/videos/lesson_1/2.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 4
    }
  },
  {
    id: 3,
    previous: 0,
    next: 5,
    video: {
      src: 'img/videos/lesson_1/2.1.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 4
    }
  },
  {
    id: 4,
    previous: 3,
    next: 5,
    directions: {
      data: `<b>DIRECTIONS:</b> <br/>Click on the 8 <br/>squares that make <br/>the other long <br/>diagonal.`,
      timeout: 6000
    },
    audio: { src: 'img/audio/lesson_1/2.mp3', start: true, controls: false },
    chessboard: {
      board: highlightCoordinates({
        showIndicators: { allSides: true },
        coordinates: ['.square-a1', '.square-b2', '.square-c3', '.square-d4', '.square-e5', '.square-f6', '.square-g7', '.square-h8'],
        prefilledCoordinates: ['.square-h1', '.square-g2', '.square-f3', '.square-e4', '.square-d5', '.square-c6', '.square-b7', '.square-a8'],
        coordinateClass: 'filled-square',
        reminder: true,
        next: 5
      })
    }
  },
  {
    id: 5,
    previous: 3,
    next: 8,
    video: {
      src: 'img/videos/lesson_1/3.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 6
    }
  },
  {
    id: 6,
    previous: 5,
    next: 8,
    text: {
      data: 'Drag the <br/>coordinates to the <br/>correct square.',
      position: 'left',
      styleClass: 'md'
    },
    audio: { src: 'img/audio/lesson_1/3.mp3', start: true, controls: false },
    chessboard: {
      board: dragDropPieces({
        showIndicators: { allSides: true },
        singleSpare: true,
        piecesArray: ['bK', 'bQ', 'bR', 'bB', 'wK', 'wQ', 'wR', 'wB'],
        validatePieces: { 'bK': ['b2'], 'bQ': ['g5'], 'bR': ['e7'], 'bB': ['d6'], 'wK': ['c4'], 'wQ': ['c2'], 'wR': ['d3'], 'wB': ['b7'] },
        pieceLimit: { bK: 1, bQ: 1, bR: 1, bB: 1, wK: 1, wQ: 1, wR: 1, wB: 1 },
        fen: '8/1B2r3/3b4/6q1/2K5/3R4/1kQ5/8',
        pieceTheme: 'coordinate_transparent',
        celebrationSound: true,
        next: 7
      })
    }
  },
  {
    id: 7,
    previous: 5,
    next: 9,
    video: {
      src: 'img/videos/lesson_1/4.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 9,
    }
  },
  {
    id: 8,
    previous: 5,
    next: 9,
    video: {
      src: 'img/videos/lesson_1/4.1.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 9,
    }
  },
  {
    id: 9,
    previous: 8,
    next: 10,
    audio: { src: 'img/audio/qa_bgm.mp3', start: true, loop: true },
    qa: {
      id: 0,
      question: 'When was chess created?',
      answer: [
        'In the beginning of time',
        'About 1500 years ago',
        'About 500 years ago',
        'Just 15 years ago'
      ],
      rightAnswer: 'About 1500 years ago',
      validateAnswer: { rightAnswer: 1, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 10,
    previous: 8,
    next: 11,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 1,
      question: 'Where was chess created?',
      answer: [
        'The United States of America',
        'Western Europe',
        'India',
        'China'
      ],
      rightAnswer: 'India',
      validateAnswer: { rightAnswer: 2, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 11,
    previous: 8,
    next: 12,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 2,
      question: 'How many squares are on the chessboard?',
      answer: [
        '8',
        '32',
        '48',
        '64'
      ],
      chessboard: {
        board: createChessboard({
          showIndicators: true,
        }),
        hint: true
      },
      rightAnswer: '64',
      validateAnswer: { rightAnswer: 3, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 12,
    previous: 8,
    next: 13,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 3,
      question: 'Which direction are vertical lines?',
      answer: [
        'Across the board',
        'Up and down the board',
        'Diagonally on the board',
        'All directions'
      ],
      chessboard: {
        board: createChessboard({
          showIndicators: true,
        }),
        hint: true
      },
      rightAnswer: 'Up and down the board',
      validateAnswer: { rightAnswer: 1, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 13,
    previous: 8,
    next: 14,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 4,
      question: 'Which direction are horizontal lines?',
      answer: [
        'Across the board',
        'Up and down the board',
        'Diagonally on the board',
        'All directions'
      ],
      chessboard: {
        board: createChessboard({
          showIndicators: true,
        }),
        hint: true
      },
      rightAnswer: 'Across the board',
      validateAnswer: { rightAnswer: 0, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 14,
    previous: 8,
    next: 15,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 5,
      question: 'What are vertical lines called in chess?',
      answer: [
        'Files',
        'Ranks',
        'Diagonals',
        'Jojos'
      ],
      chessboard: {
        board: createChessboard({
          showIndicators: true,
        }),
        hint: true
      },
      rightAnswer: 'Files',
      validateAnswer: { rightAnswer: 0, userAnswer: -1 },
      styleClass: 'md'
    }
  }, {
    id: 15,
    previous: 8,
    next: 16,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 6,
      question: 'What are horizontal lines called in chess?',
      answer: [
        'Files',
        'Ranks',
        'Diagonals',
        'Jojos'
      ],
      chessboard: {
        board: createChessboard({
          showIndicators: true,
        }),
        hint: true
      },
      rightAnswer: 'Ranks',
      validateAnswer: { rightAnswer: 1, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 16,
    previous: 8,
    next: 17,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 7,
      question: 'Which is the correct way to write a coordinate?',
      answer: [
        'Over e',
        'Up 5',
        '5E',
        'e5'
      ],
      chessboard: {
        board: createChessboard({
          showIndicators: true,
        }),
        hint: true
      },
      rightAnswer: 'e5',
      validateAnswer: { rightAnswer: 3, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 17,
    previous: 8,
    next: 18,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 8,
      question: 'Which of the coordinates is a corner square?',
      answer: [
        'a1',
        'b4',
        'd6',
        'h2'
      ],
      chessboard: {
        board: createChessboard({
          showIndicators: true,
        }),
        hint: true
      },
      rightAnswer: 'a1',
      validateAnswer: { rightAnswer: 0, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 18,
    previous: 8,
    next: 19,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    text: {
      data: 'The board is missing <br/>three dark squares. Drag <br/>the correct coordinates <br/>to the three squares that <br/>should be dark.',
      position: 'left',
      styleClass: 'xxxl'
    },
    chessboard: {
      board: dragDropPieces({
        id: 9,
        isQA: true,
        singleSpare: true,
        position: 'right',
        assignmentClass: 'assignment-1-1',
        showIndicators: { allSides: true },
        piecesArray: ['bK', 'bQ', 'bR'],
        validatePieces: { 'bK': ['b2'], 'bQ': ['g5'], 'bR': ['e7'] },
        pieceLimit: { bK: 1, bQ: 1, bR: 1 },
        coordinates: ['.square-b2', '.square-g5', '.square-e7'],
        fen: '8/4r3/8/6q1/8/8/1k6/8',
        pieceTheme: 'coordinate_blue',
      })
    }
  },
  {
    id: 19,
    previous: 8,
    next: null,
    audio: { src: null, stop: true },
    qa: {
      position: 'center',
      result: true,
      nextLesson: 'Lesson Two',
      styleClass: 'xl'
    }
  }
];

let assets = [
  '/img/background_1.png',
  '/img/background_2.png',
  '/img/chesspieces/coordinate_transparent/bK.svg',
  '/img/chesspieces/coordinate_transparent/bQ.svg',
  '/img/chesspieces/coordinate_transparent/bR.svg',
  '/img/chesspieces/coordinate_transparent/bB.svg',
  '/img/chesspieces/coordinate_transparent/wK.svg',
  '/img/chesspieces/coordinate_transparent/wQ.svg',
  '/img/chesspieces/coordinate_transparent/wR.svg',
  '/img/chesspieces/coordinate_transparent/wB.svg',
  '/img/chesspieces/coordinate_blue/bK.svg',
  '/img/chesspieces/coordinate_blue/bQ.svg',
  '/img/chesspieces/coordinate_blue/bR.svg'
];

let config = {
  config: lessonConfig,
  assets: assets
};

export default config;


// WEBPACK FOOTER //
// ./src/lessons/lesson_1/index.js